import BaseService from "@services/BaseService";

export default class DefinitionService extends BaseService {
  entity = "definitions";
}
